import React from 'react';

export const NetworkContext = React.createContext(null);

export default NetworkContext;
